(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  let blocks = document.querySelectorAll('.mega-menu__list_custom__blocks');
  blocks.forEach(block => {
      if(block.querySelectorAll(`:scope ${'li'}`).length <= 0){
          block.parentNode.classList.add('withoutBlocks');
      }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.topbar = document.querySelector('#header__topbar');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsSearchToggle = this.header.getAttribute('data-search-style') === 'toggle';
      this.headerBounds = {};
      this.setHeaderHeight(); 

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search') || this.querySelector('.search-modal__content');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.topbar) {
         document.documentElement.style.setProperty('--topbar-height', `${this.topbar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler); 
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop === 0) this.classList.remove('header-wrapper--transparent'); 
        
      if (this.headerIsAlwaysSticky) this.classList.remove('header-wrapper--transparent'); 
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
         this.header.classList.add('scrolled-past-header');
         this.classList.remove('header-wrapper--transparent'); 
        if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
           this.header.classList.add('scrolled-past-header');
         
        if (!this.preventReveal) {
           requestAnimationFrame(this.reveal.bind(this)); 
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
         this.header.classList.remove('scrolled-past-header');
         this.classList.add('header-wrapper--transparent');
         requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      if (this.headerIsSearchToggle) this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snackcombopack"] && !Shopify.designMode) return;
  try {
    
const selectedProducts = [];
const placeholders = document.querySelectorAll('.placeholder');
const totalPriceElement = document.querySelector('.total-price');
const discountPriceElement = document.querySelector('.discount-price');
const productCards = document.querySelectorAll('.product-card');
const resetButton = document.querySelector('.reset-btn');
const checkoutButton = document.querySelector('.checkout-btn');
const popupOverlay = document.getElementById('product-limit-popup');
const closePopupButton = document.getElementById('close-popup');

// Ensure placeholders are visible on page load
document.addEventListener('DOMContentLoaded', () => {
  placeholders.forEach(p => {
    p.innerHTML = '';
    p.style.border = '2px dashed #00cc00';
    p.style.display = 'flex';
    p.style.visibility = 'visible';
    p.style.opacity = '1';
  });
});

function selectProduct(card) {
  const productId = card.dataset.productId;
  const productTitle = card.dataset.productTitle;
  const productImage = card.dataset.productImage;
  const productPrice = parseFloat(card.dataset.productPrice);

  if (selectedProducts.length >= 4) {
    popupOverlay.style.display = 'flex';
    return;
  }

  selectedProducts.push({ id: productId, title: productTitle, image: productImage, price: productPrice });
  card.classList.add('selected');

  const img = card.querySelector('img');
  const imgRect = img.getBoundingClientRect();
  const clonedImg = img.cloneNode(true);
  const selectionMessageElement = document.querySelector('.selection-message');
  clonedImg.classList.add('cloned-image');
  document.body.appendChild(clonedImg);
  clonedImg.style.width = `${imgRect.width}px`;
  clonedImg.style.height = `${imgRect.height}px`;
  clonedImg.style.top = `${imgRect.top + window.scrollY}px`;
  clonedImg.style.left = `${imgRect.left + window.scrollX}px`;

  const targetSlot = selectedProducts.length;
  const targetPlaceholder = document.querySelector(`.placeholder[data-slot="${targetSlot}"]`);
  const targetRect = targetPlaceholder.getBoundingClientRect();
  const productsNeeded = 4 - selectedProducts.length;

  if (productsNeeded > 0) {
    selectionMessageElement.textContent = `You need ${productsNeeded} more to get 15% off!`;
  } else {
    selectionMessageElement.textContent = `Great! You've unlocked 15% off!`;
  }

  setTimeout(() => {
    clonedImg.style.top = `${targetRect.top + window.scrollY + targetRect.height / 2}px`;
    clonedImg.style.left = `${targetRect.left + window.scrollX + targetRect.width / 2}px`;
    clonedImg.style.transform = 'scale(0.5)';
    clonedImg.style.opacity = '0';
  }, 10);

  clonedImg.addEventListener('transitionend', () => {
    clonedImg.remove();
    updateSelectedProducts();
  });
}

productCards.forEach(card => {
  card.addEventListener('click', (event) => {
    if (event.target.classList.contains('select-btn')) return;
    selectProduct(card);
  });
});

document.querySelectorAll('.select-btn').forEach(button => {
  button.addEventListener('click', () => {
    const card = button.closest('.product-card');
    selectProduct(card);
  });
});

closePopupButton.addEventListener('click', () => {
  popupOverlay.style.display = 'none';
});

function updateSelectedProducts() {
  placeholders.forEach(p => {
    p.innerHTML = '';
    p.classList.remove('active');
    p.style.border = '2px dashed #00cc00';
    p.style.display = 'flex';
    p.style.visibility = 'visible';
    p.style.opacity = '1';
  });

  selectedProducts.forEach((product, index) => {
    const placeholder = document.querySelector(`.placeholder[data-slot="${index + 1}"]`);
    if (placeholder) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title;
      img.style.width = '80%';
      img.style.height = '80%';
      img.style.objectFit = 'contain';
      placeholder.appendChild(img);
      placeholder.classList.add('active');
    }
  });

  // Calculate total price based on all selected products
  const total = selectedProducts.reduce((sum, p) => sum + p.price, 0);
  totalPriceElement.textContent = `Total: ₹${(total / 100).toFixed(2)}`;

  if (selectedProducts.length === 4) {
    // Apply 15% discount
    const originalTotal = selectedProducts.reduce((sum, p) => sum + p.price, 0);
    const discountedTotal = originalTotal * 0.85; // 15% off

    totalPriceElement.innerHTML = `<s>₹${(originalTotal / 100).toFixed(2)}</s>`;
    discountPriceElement.textContent = `Total: ₹${(discountedTotal / 100).toFixed(2)}`;
    discountPriceElement.style.display = 'inline';
    checkoutButton.classList.add('enabled');
  } else {
    discountPriceElement.style.display = 'none';
    checkoutButton.classList.remove('enabled');
  }
}

resetButton.addEventListener('click', () => {
  selectedProducts.splice(0, selectedProducts.length);
  productCards.forEach(card => card.classList.remove('selected'));
  updateSelectedProducts();
});

checkoutButton.addEventListener("click", () => {
  if (selectedProducts.length !== 4) {
    showToast("Please select exactly 4 products to proceed.");
    return;
  }

  const cartItems = selectedProducts.map(product => `${product.id}:1`).join(',');

  // Redirect to Shopify cart with selected variants
  window.location.href = `/cart/${cartItems}?checkout`;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yourbox"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const selectedProducts = [];
  const placeholders = document.querySelectorAll(".placeholder");
  const totalPriceElement = document.querySelector(".total-price");
  const discountPriceElement = document.querySelector(".discount-price");
  const selectionMessageElement = document.querySelector(".selection-message");
  const productCards = document.querySelectorAll(".product-card");
  const resetButton = document.querySelector(".reset-btn");
  const checkoutButton = document.querySelector(".checkout-btn");
  const popupOverlay = document.getElementById("product-limit-popup");
  const closePopupButton = document.getElementById("close-popup");
  const tabButtons = document.querySelectorAll(".tab-button");

  // Initialize placeholders
  placeholders.forEach(p => {
    p.innerHTML = "";
    p.style.border = "2px dashed #00cc00";
    p.style.display = "flex";
    p.style.visibility = "visible";
    p.style.opacity = "1";
  });

  // Product selection logic with animation
  function selectProduct(card) {
    if (selectedProducts.length >= 4) {
      popupOverlay.style.display = "flex";
      return;
    }

    const productId = card.dataset.productId;
    const productTitle = card.dataset.productTitle;
    const productImage = card.dataset.productImage;
    const productPrice = parseFloat(card.dataset.productPrice);

    selectedProducts.push({ id: productId, title: productTitle, image: productImage, price: productPrice });
    card.classList.add("selected");

    // Animation for product selection
    const img = card.querySelector("img");
    const imgRect = img.getBoundingClientRect();
    const clonedImg = img.cloneNode(true);
    clonedImg.classList.add("cloned-image");
    document.body.appendChild(clonedImg);
    clonedImg.style.width = `${imgRect.width}px`;
    clonedImg.style.height = `${imgRect.height}px`;
    clonedImg.style.top = `${imgRect.top + window.scrollY}px`;
    clonedImg.style.left = `${imgRect.left + window.scrollX}px`;

    const targetSlot = selectedProducts.length;
    const targetPlaceholder = document.querySelector(`.placeholder[data-slot="${targetSlot}"]`);
    const targetRect = targetPlaceholder.getBoundingClientRect();

    setTimeout(() => {
      clonedImg.style.top = `${targetRect.top + window.scrollY + targetRect.height / 2}px`;
      clonedImg.style.left = `${targetRect.left + window.scrollX + targetRect.width / 2}px`;
      clonedImg.style.transform = "scale(0.5)";
      clonedImg.style.opacity = "0";
    }, 10);

    clonedImg.addEventListener("transitionend", () => {
      clonedImg.remove();
      updateSelectedProducts();
    });
  }

  // Event listeners for product cards and buttons
  productCards.forEach(card => {
    card.addEventListener("click", (e) => {
      if (!e.target.classList.contains("select-btn")) selectProduct(card);
    });
    card.querySelector(".select-btn").addEventListener("click", () => selectProduct(card));
  });

  // Close popup
  closePopupButton.addEventListener("click", () => {
    popupOverlay.style.display = "none";
  });

  // Update selected products display
  function updateSelectedProducts() {
    placeholders.forEach(p => {
      p.innerHTML = "";
      p.classList.remove("active");
      p.style.border = "2px dashed #00cc00";
      p.style.display = "flex";
      p.style.visibility = "visible";
      p.style.opacity = "1";
    });

    selectedProducts.forEach((product, index) => {
      const placeholder = document.querySelector(`.placeholder[data-slot="${index + 1}"]`);
      if (placeholder) {
        const img = document.createElement("img");
        img.src = product.image;
        img.alt = product.title;
        img.style.width = "80%";
        img.style.height = "80%";
        img.style.objectFit = "contain";
        placeholder.appendChild(img);
        placeholder.classList.add("active");
      }
    });

    // Update pricing and selection message
    const total = selectedProducts.reduce((sum, p) => sum + p.price, 0);
    totalPriceElement.textContent = `Total: ₹${total.toFixed(2)}`;
    const productsNeeded = 4 - selectedProducts.length;

    if (productsNeeded > 0) {
      selectionMessageElement.textContent = `You need ${productsNeeded} more to get 15% off!`;
      discountPriceElement.style.display = "none";
      checkoutButton.classList.remove("enabled");
    } else {
      const discountedTotal = total * 0.85; // 15% off
      totalPriceElement.innerHTML = `<s>Total: ₹${total.toFixed(2)}</s>`;
      discountPriceElement.textContent = `Discounted: ₹${discountedTotal.toFixed(2)}`;
      discountPriceElement.style.display = "inline";
      selectionMessageElement.textContent = `Great! You've unlocked 15% off!`;
      checkoutButton.classList.add("enabled");
    }
  }

  // Reset button logic
  resetButton.addEventListener("click", () => {
    selectedProducts.length = 0;
    productCards.forEach(card => card.classList.remove("selected"));
    updateSelectedProducts();
  });

  // Checkout button logic
  checkoutButton.addEventListener("click", () => {
    if (selectedProducts.length !== 4) {
      popupOverlay.style.display = "flex";
      popupOverlay.querySelector("p").textContent = "Please select exactly 4 products to proceed.";
      return;
    }
    const cartItems = selectedProducts.map(product => `${product.id}:1`).join(",");
    window.location.href = `/cart/${cartItems}?checkout`;
  });

  // Tab filtering logic
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      tabButtons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
      const selectedTag = button.getAttribute("data-tag");
      productCards.forEach(card => {
        const productTags = card.getAttribute("data-tags").split(" ");
        card.classList.toggle("hidden", selectedTag !== "all" && !productTags.includes(selectedTag));
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-lookbook-picker"] && !Shopify.designMode) return;
  try {
     

if (!customElements.get('slider-component-lookbook')) {
  customElements.define(
    'slider-component-lookbook',
    class SliderComponentLookbook extends SliderComponent {
    constructor() {
      super();
      this.sliderControlLinksArray = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]'));
      if(!this.sliderControlLinksArray.length) return;  
      this.enableSliderLooping = true;

      this.sliderFirstItemNode = this.slider.querySelector('.slider__slide'); 
      if (this.sliderItemsToShow.length > 0) {
        this.currentPage = 1;
      }


      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
    }

    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

      if (!isFirstSlide && !isLastSlide) return;
      
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = this.slider.scrollLeft - this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      }

      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }

    update() {
      super.update();
      this.sliderControlLinksArray = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]'));
      this.prevButton.removeAttribute('disabled'); 

      if (!this.sliderControlLinksArray.length) {
        return; 
      }

      this.sliderControlLinksArray.forEach(link => {
        link.removeAttribute('data-bullet-active');
        link.removeAttribute('aria-current');
      });

      const activeLink = this.sliderControlLinksArray[this.currentPage - 1];
      activeLink.setAttribute('data-bullet-active', '');
      activeLink.setAttribute('aria-current', true);
    }

    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = Array.from(this.parentElement.parentElement.parentElement.querySelectorAll('[data-bullet]')); 

        const isCurrentSlide = index === this.currentPage - 1; 

        linkElements.forEach(button => {
          button.setAttribute('tabindex', isCurrentSlide ? '-1' : '');
        });

        item.setAttribute('aria-hidden', !isCurrentSlide);
        item.setAttribute('tabindex', isCurrentSlide ? '' : '-1');
      });
    }

    linkToSlide(event) {
      event.preventDefault(); 
      const clickedLinkIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (clickedLinkIndex + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
 );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-lookbook-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lookbook-component')) {
customElements.define(
'lookbook-component',
class LookbookComponent extends HTMLElement {
constructor() {
super();
this.popoverButtons = this.querySelectorAll('[data-popover-bullet]');
this.popperInstances = new Map();

this.popoverButtons.forEach((button) =>
button.addEventListener('click', () => {
const popoverID = button.getAttribute('data-popover');
if (this.popperInstances.has(popoverID)) {
this.hidePopper(popoverID);
} else {
this.hideAllPopovers();
this.showPopper(popoverID);
}
})
);

this.slider = this.querySelector('[id^="Slider-"]');
this.slider.addEventListener('scroll', () => this.hideAllPopovers());

document.addEventListener('click', (event) => {
const target = event.target;
const isButton = Array.from(this.popoverButtons).some((button) => button.contains(target));
const isPopover = Array.from(this.popperInstances.values()).some((popper) =>
popper.state.elements.popper.contains(target)
);

if (!isButton && !isPopover) {
this.hideAllPopovers();
}
});
}

connectedCallback() {
const handleIntersection = (entries) => {
entries.forEach((entry) => {
if (!entry.isIntersecting) {
this.hideAllPopovers();
}
});
};
const observer = new IntersectionObserver(handleIntersection.bind(this));
observer.observe(this);
}

createInstance(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
const popperInstance = Popper.createPopper(popperButton, popperPopup, {
placement: 'auto',
modifiers: [
{
name: 'offset',
options: {
offset: [0, 6],
},
},
{
name: 'flip',
options: {
allowedAutoPlacements: ['left', 'right', 'top', 'bottom'],
rootBoundary: 'viewport',
},
},
],
});
this.popperInstances.set(popoverID, popperInstance); // Store the popper instance in the map
}
}

destroyInstance(popoverID) {
if (this.popperInstances.has(popoverID)) {
const popperInstance = this.popperInstances.get(popoverID);
popperInstance.destroy();
this.popperInstances.delete(popoverID); // Remove the popper instance from the map
}
}

showPopper(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
popperPopup.setAttribute('is-open', '');
popperButton.setAttribute('is-active', '');
this.createInstance(popoverID);
}
}

hidePopper(popoverID) {
const popperPopup = this.querySelector(`#popover-id-${popoverID}`);
const popperButton = this.querySelector(`#button-id-${popoverID}`);

if (popperPopup && popperButton) {
popperPopup.removeAttribute('is-open');
popperButton.removeAttribute('is-active');
this.destroyInstance(popoverID);
}
}
hideAllPopovers() {
this.popoverButtons.forEach((button) => {
const popoverID = button.getAttribute('data-popover');
this.hidePopper(popoverID);
});
}
}
);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zmz-ticker"] && !Shopify.designMode) return;
  try {
    

  class TickerElement extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const tickerList = this.querySelector('.ticker__inner');
		const tickerDirect = parseInt(this.dataset.direction);
		const tickerListWidth = tickerList.offsetWidth;
		const cloneEl = tickerList.cloneNode(true);
		cloneEl.classList.add('cloned');
		this.append(cloneEl);

		let start = window.performance.now();
		let progress;
		let translateX;
		let duration = 21000;
		let mouseEntered = false;

		const handleMouseEnter = () => {
		mouseEntered = true;
		};

		const handleMouseLeave = () => {
		mouseEntered = false;
		};

		this.parentElement.addEventListener('mouseenter', handleMouseEnter);
		this.parentElement.addEventListener('mouseleave', handleMouseLeave);

		const tick = (now) => {
		if (mouseEntered === false) {
			progress = (now - start) / duration;

			if (progress > 1) {
			progress %= -1;
			start = now;
			}

			if (tickerDirect == 1) {
			translateX = tickerListWidth * progress - tickerListWidth;
			cloneEl.style.transform = `translate3d(${translateX}px, 0 , 0)`;
			tickerList.style.transform = `translate3d(${translateX}px, 0 , 0)`;
			} else {
			translateX = tickerListWidth * progress;
			tickerList.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
			cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
			}
		}

		window.requestAnimationFrame(tick);
		};

		tick(window.performance.now());
	}
  }

  customElements.define('ticker-element', TickerElement);


  } catch(e) { console.error(e); }
})();
})();
